<template>
    <div :class="$style.trackingCodeDialog">
        <pt-dialog :model-value="true" width="622px" @close="handleClose" :title="content?.title">
            <div :class="$style.dialogContent">
                <p :class="$style.des">{{ content?.content }}</p>
            </div>
            <template #footer>
                <pt-button type="outline" @click="handleViewDemo">
                    {{ content?.demoButton }}
                </pt-button>
                <pt-button :class="$style.dialogButton" @click="onConfirm">
                    {{ $t('guide.guide_popover_step_2_btn_install') }}
                </pt-button>
            </template>
        </pt-dialog>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useGuideStore, GuideKey } from '@/pages/master/store/guide.store';
import useEventBus from '@assets/plugins/eventBus';
import { useI18n } from 'vue-i18n';

interface Props {
    currentGuideStepKey: GuideKey;
}
const props = defineProps<Props>();
const { eventBus } = useEventBus();
const { t } = useI18n();
const { openHeatmapDemo, openEditorDemo } = useGuideStore();
const emit = defineEmits(['close']);

const demoButtonText = computed(() => {
    if (props.currentGuideStepKey === 'startGuide_heatmap') {
        return t('guide.view_heatmap_demo_entry');
    } else if (props.currentGuideStepKey === 'startGuide_inline') {
        return t('experience.common.experience_demo_entry');
    }
});

const content = computed(() => {
    switch (props.currentGuideStepKey) {
        case 'startGuide_heatmap':
            return {
                title: t('guide.heatmap_track_code_notice_title'),
                content: t('guide.heatmap_track_code_notice_content'),
                demoButton: t('guide.heatmap_track_code_notice_demo_btn')
            };
            break;
        case 'startGuide_inline':
            return {
                title: t('guide.editor_track_code_notice_title'),
                content: t('guide.editor_track_code_notice_content'),
                demoButton: t('guide.editor_track_code_notice_demo_btn')
            };
            break;
    }
});

function onConfirm() {
    emit('close');
    eventBus.$emit('showSetup');
}

function handleClose() {
    emit('close');
}

function handleViewDemo() {
    if (props.currentGuideStepKey === 'startGuide_heatmap') {
        openHeatmapDemo();
    } else if (props.currentGuideStepKey === 'startGuide_inline') {
        openEditorDemo();
    }
    emit('close');
}
</script>

<style lang="scss" module>
@import '@style/import.scss';
.trackingCodeDialog {
    .dialogContent {
        text-align: left;
        .des {
            width: 100%;
            word-break: break-word;
        }
    }

    :global {
        .pt-dialog__footer {
            padding: 28px 48px 40px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
        }
        .pt-button {
            margin-left: 8px;
        }
    }
}
</style>
